module.exports = __webpack_public_path__ + "static/demo-screen-1-4708a991284eeb9413325f0d45a034b4.png";